module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2d"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter3"
    }
  }), _vm._v("BIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" Doctor I have introduced into the dialogue we have just read, is not a creature of imagination like the Chloris of other days, but a real living Doctor. Those who know me, will remember R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ICHERAND.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I thought of him I could not but have reference to those who preceded him, and I saw with pride that from Belley, from the department of Ain, my native soil, for a long time physicians of the greatest distinction had come. I could not resist the temptation to erect a brief monument to them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the regency Doctors Genin and Civoct were in full possession of practice, and expended in their country a wealth they had honorably acquired. The first was altogether H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IPPOCRATITE")]), _vm._v("; he proceeded "), _c('i', [_vm._v("secundum artem;")]), _vm._v(" the second was almost monopolized by women, and had as his device, as Tacitus would have said, "), _c('i', [_vm._v("res novas molientem.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About 1780 Chapelle became distinguished in the dangerous career of a military surgeon. About 1781 Doctor Dubois had great success in sundry maladies, then very much "), _c('i', [_vm._v("a la mode,")]), _vm._v(" and in nervous diseases. The success he obtained was really wonderful.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unfortunately he inherited a fortune and became idle, and was satisfied to be a good story-teller. He was very amusing, and contrived to survive the dinners of the new and old regime."), _c('a', {
    attrs: {
      "id": "ipg35fn1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#pg35fn1"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("About the end of the reign of Louis XV., Dr. Coste, a native of Chatillon came to Paris; he had a letter from Voltaire to the Due de Choiseuil, the good wishes of whom he gained as soon as he had seen him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Protected by this nobleman, and by the Duchess of Grammont, his sister, young Coste advanced rapidly, and in a short time became one of the first physicians of Paris.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The patronage he had received took him from a profitable career to place him at the head of the medical department of the army which France sent to the United States, who then were contending for their independence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having fulfilled his mission, Coste returned to France, and almost unseen lived through the evil days of 1793. He was elected maire of Versailles, and even now the memory of his administration, at once mild, gentle and paternal, has been preserved.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Directors now recalled him to the charge of the medical department of the army. Bonaparte appointed him one of the three Inspectors General of the service; the Doctor was always the friend, protector, and patron of the young men who selected that service. He was at last appointed Physician of the Invalides, and discharged the duties until he died.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Such service the Bourbons could not neglect, and Louis XVIII. granted to Doctor Coste the cordon of Saint Michel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Doctor Coste died a few years since, leaving behind kind recollections, and a daughter married to M. Lalot, who distinguished himself in the Chamber of Deputies by his eloquent and profound arguments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One day when we had dined with M. Favre, the "), _c('i', [_vm._v("Curé")]), _vm._v(" of St. Laurent, Doctor Coste told me of a difficulty he had, the day before, with the Count de Le Cessac, then a high officer of the ministry of war, about a certain economy which the latter proposed as a means of paying his court to Napoleon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("The economy consisted in retrenching the allowances of hospital, so as to restrict men who had wounds from the comforts they were entitled to.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Doctor Coste said such measures were abominable, and he became angry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I do not know what the result was, but only that the sick soldiers had their usual allowances, and that no change was made.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was appointed Professor of the Faculty of Medicine. His style was simple and his addresses were plain and fruitful. Honors were crowded on him. He was appointed Physician to the Empress Marie Louise. He did not, however, fill that place long, the Emperor was swept away, and the Doctor himself succumbed to a disease of the leg, to which he had long been subject.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bordier was of a calm disposition, kind and reliable")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About the 18th century appeared Bichat, all of the writings of whom bear the impress of genius. He expended his life in toil to advance science, and joined the patience of restricted minds to enthusiasm. He died at the age of thirty, and public honors were decreed to his memory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At a later day came Doctor Montégre, who carried philosophy into clinics. He was the editor of the Gazette de Santé, and at the age of forty died in the Antilles, whither he had gone to complete his book on the "), _c('i', [_vm._v("Vomite Negro.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the present moment Richerand stands on the highest degree of operative medicine, and his Elements of Physiology have been translated into every language. Appointed at an early date a Professor of the Faculty of Paris, he made all rely fully on him. He is the keenest, gentlest, and quickest operator in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Recamier, a professor of the same faculty, sits by his side.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The present being thus assured, the future expands itself before us! Under the wings of these mighty Professors arise "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("young men of the same land, who seek to follow their honorable examples.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janin and Manjot already crush the pavement of Paris, Manjot devotes himself to the diseases of children; he has happy inspirations, and soon will tell the public what he has discovered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I trust my readers will pardon this digression of an old man, who, during an absence of thirty years, has neither forgotten his country nor his countrymen. I could not however omit all those physicians, the memory of whom is yet preserved in their birth-place, and who, though not conspicuous, had not on that account the less merit or worth."), _c('a', {
    attrs: {
      "id": "ipg38fn1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#pg38fn1"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "pg35fn1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#ipg35fn1"
    }
  }, [_vm._v("*")]), _vm._v(" I smiled when I wrote the above, for it recalled to me an Academician, the eulogium of whom Fontenello undertook. The deceased know only how to play at all games. Fontenelle made a very decent oration, however, about him.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "pg38fn1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#ipg38fn1"
    }
  }, [_vm._v("*")]), _vm._v(" The translator thinks several have made world-renowned names.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01d20ba7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter3.vue
// module id = 87
// module chunks = 0